import { whiteColor } from "@config"
import createPage from "@src/components/page"
import React from "react"
import * as styles from "./pagePublish.module.scss"

import d1Img from "@images/png/19.png"
import d3Img from "@images/png/20.png"
import d2Img from "@images/png/21.png"
import Numbers from "@src/components/numbers"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { animated } from "@react-spring/web"

const parseData = ({
  attributes: {
    "articles-count": articles,
    "shows-count": shows,
    "talks-count": talks,
  },
}) => ({
  articles,
  shows,
  talks,
})

const PagePublish = createPage(
  ({ data, offset }) => {
    const { articles, shows, talks } = parseData(data)
    const anime1Styles = useEnteringTrail(3, offset)
    const anime2Styles = useEnteringTrail(1, offset, { step: 0.2, type: "mt" })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.4, type: "mrb" })
    const anime4Styles = useEnteringTrail(1, offset, { step: 0.7, type: "mlb" })
    return (
      <>
        <div className={styles.icons}>
          <animated.img
            style={anime2Styles[0]}
            src={d1Img}
            className={styles.d1}
            alt="d"
          />
          <div>
            <animated.img
              style={anime4Styles[0]}
              src={d3Img}
              className={styles.d3}
              alt="d"
            />
            <animated.img
              style={anime3Styles[0]}
              src={d2Img}
              className={styles.d2}
              alt="d"
            />
          </div>
        </div>
        {articles > 0 && (
          <animated.div className="line2" style={anime1Styles[0]}>
            2021年 {callYou(data)}一共发布了
            <br />
            <div className={styles.flexTop}>
              <Numbers>{articles}</Numbers>篇文章
            </div>
          </animated.div>
        )}
        {shows > 0 && (
          <animated.div style={anime1Styles[1]}>
            参与<Numbers>{shows}</Numbers>电台+视频
          </animated.div>
        )}
        {talks > 0 && (
          <animated.div style={anime1Styles[2]}>
            话题发文<Numbers>{talks}</Numbers>次
          </animated.div>
        )}
      </>
    )
  },
  {
    className: styles.page,
  }
)

export const pagePublishData = {
  key: "publish",
  bg: whiteColor,
  Page: PagePublish,
  shouldHide: (data) => {
    const { articles, shows, talks } = parseData(data)
    return articles === 0 && shows === 0 && talks === 0
  },
}

PagePublish.displayName = "PagePublish"
export default PagePublish
